<template>
  <div>
    <div v-for="(user, index) in this.users" v-bind:key='index'
         class='mb-5 border-b-2 border-blue-800'>
      <header class="flex items-center space-x-2">
        <h3 class="font-bold">{{ user.attributes.given_name }}
          {{ user.attributes.family_name }}</h3>
      </header>
      <table class="mt-2">
        <tbody>
        <tr>
          <td class="w-1/3 p-2 font-medium">Status</td>
          <td><m-badge :type="statusType[index]">{{ user.status }}</m-badge></td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">Email</td>
          <td>{{ user.attributes.email }}</td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">Username</td>
          <td>{{ user.username }}</td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">ID</td>
          <td>{{ user.attributes.sub }}</td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">Created</td>
          <td>{{ user.createdAt | moment('DD/MM/YYYY') }}</td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">Last Updated</td>
          <td>{{ user.updatedAt | moment('DD/MM/YYYY') }}</td>
        </tr>
        <tr>
          <td class="w-1/3 p-2 font-medium">Account Owner Email</td>
          <td>{{ user.ownerEmailAddress }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-info',
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  computed: {
    statusType() {
      return this.users.map(user => (user.status === 'CONFIRMED' ? 'GREEN' : 'RED'));
    },
  },
};
</script>

<style scoped>
</style>
